export default __webpack_public_path__ + "static/media/badge_new.e432212f.svg";